export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6905.d3215d32.jpg";